var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9842 7.92041H8.99336V7.94943C8.76122 7.94943 8.55811 8.15254 8.55811 8.38468V15.4357C8.55811 15.5808 8.67417 15.6679 8.79024 15.6679H13.9842C14.1003 15.6679 14.1873 15.5808 14.1873 15.4648V8.12353C14.1873 8.00746 14.1003 7.92041 13.9842 7.92041Z",
    fill: "#CDA876"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 8.15331V15.5236C15.8415 15.6106 15.9286 15.6977 16.0156 15.6977H21.2096C21.3547 15.6977 21.4417 15.5816 21.4417 15.4655V8.38545C21.4417 8.15331 21.2386 7.9502 21.0065 7.9502H16.0156C15.8996 7.9502 15.8125 8.03725 15.8125 8.15331Z",
    fill: "#CDA876"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9551 16.8857H3.97334C3.7412 16.8857 3.53809 17.0889 3.53809 17.321V25.939C3.53809 26.1711 3.7412 26.3742 3.97334 26.3742H13.9841C14.0711 26.4032 14.1582 26.3162 14.1582 26.2001V17.0889C14.1582 16.9728 14.0711 16.8857 13.9551 16.8857Z",
    fill: "#CDA876"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0264 16.8857H16.0156C15.8996 16.8857 15.8125 16.9728 15.8125 17.0889V26.2001C15.8125 26.3162 15.8996 26.4032 16.0156 26.4032H26.0264C26.2585 26.4032 26.4616 26.2001 26.4616 25.968V17.35C26.4616 17.0889 26.2875 16.8857 26.0264 16.8857Z",
    fill: "#CDA876"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5109 6.52737C19.1783 6.0631 19.3814 5.25063 19.0913 4.58325C18.8301 4.00291 18.2498 3.59668 17.5824 3.6257C17.1471 3.6257 16.7409 3.82881 16.4507 4.148L15.087 5.56981C15.0289 5.62785 14.9709 5.62785 14.9129 5.56981L13.5491 4.11898C13.2589 3.7998 12.8527 3.59668 12.4174 3.59668C11.75 3.59668 11.1697 3.9739 10.9085 4.55423C10.6184 5.22161 10.8215 6.03408 11.4889 6.49835C11.75 6.67245 12.0692 6.7595 12.3594 6.7595H14.9999L17.6404 6.78852C17.9596 6.78852 18.2788 6.70147 18.5109 6.52737Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ3);
export default __webpack_public_path__ + "static/media/q3.298e9cd4ca9362f7b4f41758f76058d4.svg";
export { ForwardRef as ReactComponent };